import React from 'react';
import Icon from '../../../components/AppIcon';

const AchievementBadges = ({ badges }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading">
          Logros Recientes
        </h3>
        <Icon name="Award" size={24} color="var(--color-primary)" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {badges?.map((badge) => (
          <div
            key={badge?.id}
            className={`
              flex flex-col items-center p-4 rounded-xl border-2 transition-smooth
              ${badge?.unlocked 
                ? 'border-primary bg-primary/5 hover:elevation-2' :'border-border bg-muted opacity-50'
              }
            `}
          >
            <div 
              className={`
                w-16 h-16 rounded-full flex items-center justify-center mb-3
                ${badge?.unlocked ? 'bg-primary' : 'bg-muted-foreground'}
              `}
            >
              <Icon 
                name={badge?.icon} 
                size={32} 
                color={badge?.unlocked ? 'var(--color-primary-foreground)' : 'var(--color-background)'}
              />
            </div>
            <p className="text-sm font-medium text-foreground text-center mb-1">
              {badge?.title}
            </p>
            <p className="text-xs text-muted-foreground text-center line-clamp-2">
              {badge?.description}
            </p>
            {badge?.unlocked && badge?.date && (
              <p className="text-xs text-primary font-medium mt-2 data-text">
                {new Date(badge.date)?.toLocaleDateString('es-PE', { 
                  day: '2-digit', 
                  month: '2-digit', 
                  year: 'numeric' 
                })}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AchievementBadges;